import { createRequest, RequestConfig } from 'app/common/api';

import { TTerminal } from '../core/terminal';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_terminal',
};

type GetTerminalParams = {
  id: TTerminal['id'];
};

export const getTerminalRequest = ({ id }: GetTerminalParams) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: { id: String(id) },
  });
